import { IProfesionalActivity } from "Models/ProfesionalActivity";
import customFetchBase from "./customFetchBase";
import { createApi } from "@reduxjs/toolkit/query/react";


export const profesionalActivityApi = createApi({
    reducerPath: "profesionalActivityApi",
    baseQuery: customFetchBase,
    tagTypes: ["ProfesionalActivity"],
    keepUnusedDataFor: 300,  // Keep cached data for 5 minutes globally
    refetchOnReconnect: true, // Refetch data when reconnected to the network
    refetchOnFocus: true, // Refetch data when the window is focused again
    endpoints: (builder) => ({
        getAllProfesionalActivities: builder.query<IProfesionalActivity[], void>({
            query() {
                return {
                    url: "profesionalActivities/",
                    method: "GET",
                    credentials: "include",
                };
            },
            providesTags: () => [{ type: "ProfesionalActivity" }],
            transformResponse: (results: { data: IProfesionalActivity[] }) => {
                return results.data;
            },
        }),
           })
});
export const { useGetAllProfesionalActivitiesQuery } = profesionalActivityApi;